var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pvd-loading-spinner',{staticClass:"mt-4",attrs:{"active":"true","type":"brand"}})
}
var staticRenderFns = []

export { render, staticRenderFns }